import React from 'react';
import { ReactComponent as ModalIcon } from '../../images/Icons/smiles.svg';

export default function ModalsHeaderHowWasYourDay() {

  return (
    <div>
      <div className="ModalsHeader">
        <div>
          <ModalIcon />
        </div>
      </div>
      <div className="ModalsHeaderShadow"></div>
    </div>
  );
}